import { render, staticRenderFns } from "./classical-inbox-chat.vue?vue&type=template&id=05ae432a"
import script from "./classical-inbox-chat.vue?vue&type=script&lang=js"
export * from "./classical-inbox-chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports